import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsOptional, IsString, IsUUID, IsEnum } from 'class-validator'
import { OffsetPaginationQueryDto, SortOrder } from '@sphere/shared/domain'
import { ActivityVisibility } from '../../../enums'

export class ListTemplatesDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({
    type: 'string',
    description: "Filtrer par type d'activité",
    format: 'uuid',
  })
  @IsOptional()
  @IsUUID('4')
  typeId?: string

  @ApiPropertyOptional({
    type: 'string',
    description: 'Filtrer par propriétaire',
    format: 'uuid',
  })
  @IsOptional()
  @IsUUID('4')
  ownerUserId?: string

  @ApiPropertyOptional({
    description: 'Filtrer par visibilité',
    enum: ActivityVisibility,
  })
  @IsOptional()
  @IsEnum(ActivityVisibility)
  visibility?: ActivityVisibility

  @ApiPropertyOptional({
    type: 'string',
    description: 'Champ de tri',
    example: 'updatedAt',
  })
  @IsOptional()
  sort?: string = 'updatedAt'

  @ApiPropertyOptional({
    description: 'Ordre de tri',
    enum: SortOrder,
    example: SortOrder.DESC,
  })
  @IsOptional()
  order?: SortOrder = SortOrder.DESC
}
